import { useBrowserTitle } from './useBrowserTitle';
import { useEmitActiveRoute } from './useEmitActiveRoute';
import { useTrackPage } from './useTrackPage';

export function RouterSideEffects() {
  useBrowserTitle();
  useEmitActiveRoute();
  useTrackPage();

  return null;
}
